import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { DayPicker, DateRange, DateAfter } from "react-day-picker";
import "./date-picker.css";
// import("react-day-picker/style.css");
import "@daypicker/react/style.css";

type Props = {
  value: DateRange | undefined;
  onChange: (range: DateRange | undefined) => void;
};

const matcher: DateAfter = { after: new Date()};

function DatePicker({ value, onChange }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const displayValue =
    value?.from && value?.to
      ? `${value.from.toLocaleDateString()} - ${value.to.toLocaleDateString()}`
      : "";

  return (
    <div className="date-range-picker" ref={containerRef}>
      <input
        type="text"
        className="border-1 input-filter"
        value={displayValue}
        placeholder={t("common:fields.dateRange")}
        readOnly
        onClick={() => setIsOpen(!isOpen)}
      />

      {isOpen && (
        <div className="date-range-calendar">
          <DayPicker
            mode="range"
            disabled={matcher}
            captionLayout="dropdown-months"
            selected={value}
            onSelect={onChange}
          />
          <span
            className="clear-button"
            onClick={() => onChange(undefined)}
          >
            {t("common:actions.reset")}
          </span>
        </div>
      )}
    </div>
  );
}

export default DatePicker;
